export default {
  name: 'internalcommunication',
  data () {
    return {
      label: 'INTERNAL COMMUNICATION',
      componentValue: this.value
    }
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  watch: {
    componentValue: function () {
      this.$emit('input', this.componentValue)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/internalcommunication/script.js